module.exports = __webpack_public_path__ + "static/media/package_selection.789eb7ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/package_selection.jpg
// module id = 221
// module chunks = 0